// extracted by mini-css-extract-plugin
export default {"legend_item":"styles_legend_item__bgPOW"};